import type { CartUI } from '@libs/common-node';

import { isProductRxFoodItem, isProductRxMedItem } from './productVetRxColdItem';

export const cartHasVetDietItem = (cart: Nullable<CartUI>) =>
    cart?.fulfillmentGroups?.some(group => group.items?.some(item => isProductRxFoodItem(item)));

export const cartHasVetRxItem = (cart: Nullable<CartUI>) =>
    cart?.fulfillmentGroups?.some(group => group.items?.some(item => isProductRxMedItem(item)));
